import { render, staticRenderFns } from "./TimeStampButton.vue?vue&type=template&id=3781b0e8"
import script from "./TimeStampButton.vue?vue&type=script&lang=js"
export * from "./TimeStampButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports